module.exports = __webpack_public_path__ + "components/star-rating/static/yellow/5-42f01c6671808e5cd2714bd1b7d75151.svg";